// Liste des formes juridiques par pays (codes ISO 3166-1 alpha-2)
// Utilisée dans SocietesPage et lors de la création/édition d'une société.

export const COUNTRIES = [
  { code: "FR", label: "France", flag: "🇫🇷", currency: "EUR" },
  { code: "BE", label: "Belgique", flag: "🇧🇪", currency: "EUR" },
  { code: "CH", label: "Suisse", flag: "🇨🇭", currency: "CHF" },
  { code: "LU", label: "Luxembourg", flag: "🇱🇺", currency: "EUR" },
  { code: "DE", label: "Allemagne", flag: "🇩🇪", currency: "EUR" },
  { code: "ES", label: "Espagne", flag: "🇪🇸", currency: "EUR" },
  { code: "IT", label: "Italie", flag: "🇮🇹", currency: "EUR" },
  { code: "PT", label: "Portugal", flag: "🇵🇹", currency: "EUR" },
  { code: "NL", label: "Pays-Bas", flag: "🇳🇱", currency: "EUR" },
  { code: "US", label: "Etats-Unis", flag: "🇺🇸", currency: "USD" },
  { code: "GB", label: "Royaume-Uni", flag: "🇬🇧", currency: "GBP" },
];

export const LEGAL_FORMS = {
  FR: ["SAS", "SASU", "SARL", "EURL", "SA", "SCI", "SCIC", "SCOP", "SNC", "SCA", "GIE", "Auto-entrepreneur", "EI", "EIRL", "Association loi 1901", "Autre"],
  BE: ["SA", "SRL", "SPRL", "SCRL", "SNC", "SCS", "ASBL", "Independant", "Autre"],
  CH: ["SA", "Sarl", "SNC", "Societe en commandite", "Entreprise individuelle", "Cooperative", "Association", "Autre"],
  LU: ["SA", "SARL", "SARL-S", "SCS", "SCSp", "SE", "Entreprise individuelle", "Autre"],
  DE: ["GmbH", "UG (haftungsbeschraenkt)", "AG", "KG", "OHG", "GmbH & Co. KG", "Einzelunternehmen", "Autre"],
  ES: ["SL", "SLU", "SA", "SLNE", "SC", "Cooperativa", "Autonomo", "Autre"],
  IT: ["S.r.l.", "S.r.l.s.", "S.p.A.", "S.a.s.", "S.n.c.", "Ditta individuale", "Autre"],
  PT: ["Lda.", "Unipessoal Lda.", "S.A.", "Sociedade em comandita", "Empresario em nome individual", "Autre"],
  NL: ["BV", "NV", "VOF", "CV", "Maatschap", "Eenmanszaak", "Cooperatie", "Autre"],
  US: ["LLC", "Single-Member LLC", "C-Corp", "S-Corp", "Sole Proprietorship", "General Partnership", "Limited Partnership (LP)", "LLP", "Nonprofit", "Autre"],
  GB: ["Ltd", "PLC", "LLP", "Sole Trader", "General Partnership", "Limited Partnership", "CIC", "Charity", "Autre"],
};

export const getLegalForms = (countryCode) => {
  return LEGAL_FORMS[countryCode] || LEGAL_FORMS.FR;
};

export const getCountry = (code) => COUNTRIES.find(c => c.code === code);

// Map old "France"/"Belgique" labels to ISO codes for backward compat
export const labelToCode = (label) => {
  if (!label) return "FR";
  const found = COUNTRIES.find(c => c.label.toLowerCase() === String(label).toLowerCase() || c.code.toLowerCase() === String(label).toLowerCase());
  return found?.code || "FR";
};

// Modules disponibles pour configuration par société
// Chaque module est independant (default OFF). Agenda et Messages restent toujours activés cross-société (pas listés ici).
export const SOCIETE_MODULES = [
  { key: "mon_espace", label: "Mon espace", desc: "Notes, todos, fichiers personnels (hors agenda et messages qui restent globaux)", icon: "User", group: "Personnel" },
  { key: "force_de_vente", label: "Force de vente", desc: "Clients, devis, facturation, CRM, audits, documents", icon: "Briefcase", group: "Commercial" },
  { key: "blitzz_accompaniment", label: "Blitzz - Accompagnement", desc: "Module accompagnement Blitzz (uniquement si la societe a un accompagnement actif)", icon: "Sparkles", group: "Blitzz" },
  { key: "gestion_activite", label: "Gestion d'activite", desc: "Depenses, encaissements, comptabilite, pilotage compta", icon: "TrendingUp", group: "Operations" },
  { key: "formation", label: "Formation", desc: "Formations, sessions, stagiaires, BPF (selon offre tenant)", icon: "GraduationCap", group: "Formation" },
];

// Permissions des modules en fonction de l'offre tenant (si l'offre ne couvre pas le module, on grise)
export const isModuleAvailableForTenant = (moduleKey, tenantPlan) => {
  // Default: tous les modules sont disponibles. Plan-specific gating peut être ajouté ici.
  if (!tenantPlan) return true;
  // exemple: pack essentiel n'inclut pas formation
  if (moduleKey === "formation" && tenantPlan === "essentiel") return false;
  return true;
};
